// src/data/userList.js
const userList = [
    { email: "user1@gmail.com", password: "password123", role: "user" },
    { email: "user2@hotmail.com", password: "securePass456", role: "user" },
    { email: "admin@example.com", password: "adminPass789", role: "admin" },
];
  
export default userList;
  